import { getAuthorisation, lowestAuthorisation } from "@iventis/utilities";
import { useMemo } from "react";
import { ScheduleMachineContext } from "./schedule.machine.types";

export const useSchedulePermission = (scheduleContext: ScheduleMachineContext) => useMemo(() => scheduleContext.scheduleNode?.authorisation, [scheduleContext.scheduleNode?.id]);

/**
 * Permission root schedule version (e.g. Competition v1)
 */
export const useScheduleVersionPermission = (scheduleContext: ScheduleMachineContext) =>
    useMemo(() => scheduleContext.scheduleNode && getAuthorisation(scheduleContext.scheduleNode.childNodes, scheduleContext.selectedScheduleVersionRootId), [
        scheduleContext.selectedScheduleVersionRootId,
    ]);

/**
 * Lowest permission on discipline schedule/s (e.g. Football 1)
 */
export const useDisciplineScheduleVersionPermission = (scheduleContext: ScheduleMachineContext) =>
    useMemo(() => scheduleContext.scheduleNode && lowestAuthorisation(scheduleContext.scheduleNode.childNodes, scheduleContext.selectedSubScheduleIds), [
        scheduleContext.selectedSubScheduleIds,
    ]);
